import React from "react";

import { Dimmer, Loader } from "semantic-ui-react";

import { URL } from 'Constants'
import { logout } from 'helpers/api'

class Logout extends React.Component {
  componentDidMount() {
    logout().then(() => {
      console.log("Heading to orion to logout");
      window.location = URL.ORIONLOGOUT;
    })
    .catch(error => {
        console.log("Logout call to [%s] failed: %O",URL.AUTHLOGOUT,error);
    });
  }

  render() {
    return (
      <Dimmer active inverted>
        <Loader />
      </Dimmer>
    );
  }
}

export default Logout;
